import { SET_LANGUAGE } from '../types/index'
import { LocaleStorage } from '../../storage/index'

const initialState = {
  keys: {},
  code: null
}

export default function ( state = initialState, action ) {
  switch( action.type ) {
  case SET_LANGUAGE:
    LocaleStorage.addLanguageLoaded( action.payload )
    return {
      keys: action.payload.data,
      code: action.payload.code
    }
  default: 
    return state
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/language.js